<template>


    <div v-if="isdisplay"   class="hs-overlay  ti-offcanvas ti-offcanvas-right open opened" tabindex="-1">
        <div class="ti-offcanvas-header">
            <h5 class="ti-offcanvas-title">
                SERVEURS
            </h5>
            <button type="button" class="ti-btn flex-shrink-0 p-0 transition-none text-gray-500 hover:text-gray-700
                    focus:ring-gray-400 focus:ring-offset-white dark:text-[#8c9097] dark:text-white/50 dark:hover:text-white/80 dark:focus:ring-white/10
                    dark:focus:ring-offset-white/10"  @click="closeview">
                <span class="sr-only">Close modal</span>
                <svg class="w-3.5 h-3.5" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z" fill="currentColor"></path>
                </svg>
            </button>
        </div>
        <div class="ti-offcanvas-body !h-[90%] !p-0">
            <div>

                <div class=" xl:col-span-12  col-span-12 mt-4 mb-4">
                    <input v-model="searchword"  class="form-control form-control-lg w-full" type="text"
                           placeholder="🔍 Rechercher un serveur..."
                           aria-label=".form-control-lg example">
                </div>

                <!--div class="servers-list">
                    <div
                            v-for="server in filterdata"
                            :key="server.id"
                            @dblclick="handlercurrentserveur(server)"
                            :class="['server-item', { unavailable: !server.available }]"
                    >
                        <div class="server-avatar">
                            <i class="fas fa-user"></i>
                        </div>
                        <div class="server-info">
                            <div class="server-name">{{ server.name }}</div>
                            <div class="server-status">
                <span :class="['status-badge', server.available ? 'available' : 'unavailable']">
                  {{ server.available ? 'Disponible' : 'Indisponible' }}
                </span>
                            </div>
                            <div class="server-hint">Double-clic pour sélectionner</div>
                        </div>
                    </div>
                </div-->


                <div class="servers-list">
                    <div
                            v-for="server in filterdata"
                            :key="server.id"
                            @dblclick="handlercurrentserveur(server)"
                            class="server-item"
                    >
                        <div class="server-avatar">
                            <i class="fas fa-user"></i>
                        </div>
                        <div class="server-info">
                            <div class="server-name">{{ server.name }}</div>
                            <div class="server-status">
                <span class="status-badge available">
                  Disponible
                </span>
                            </div>
                            <div class="server-hint">Double-clic pour sélectionner</div>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </div>


    <div @click="closeview"  v-if="isdisplay"
          class="fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity backdrop-blur-sm" style="z-index: 149;"></div>


</template>

<script>
    import { inject } from 'vue';
    export default {
        /* eslint-disable */
        name: "serveur",

        watch: {
           /* searchword: function(newvalue,oldvalue){

                this.page=1

            },*/


        },
        computed:{

            filterdata(){

                let mvalue=this.servers;

                if (this.searchword!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {
                        return    post.name.toLowerCase().includes(t.searchword.toLowerCase())

                    })
                }
                return mvalue ;
            },
        },

        data() {
            return {
                searchword: "",
                isdisplay: false,
                servers:[],
                currentServer:{}

            };
        },

        methods: {


            handlercurrentserveur(serveur){
                this.$emit('selectserveur',serveur);
                this.isdisplay=false;
            },

            closeview(){
                this.isdisplay=false;
            },

            close(){
                this.isdisplay=false;

                this.$emit('closed');
            },


            show(servers,currentServer){

                this.servers=servers
                this.currentServer=currentServer



                this.isdisplay=true;

            },



        },

        setup(props) {
            // Injecter la méthode 'addCompte' provenant du parent
            const selectServer = inject('selectServer');


            const handleserversselectServer = (value) => {

                // Appel de la méthode injectée
                if (selectServer) {

                    console.log("value selectServer ",value)

                    selectServer(value);
                }

            };




            return {
                handleserversselectServer,

            };
        },



    }
</script>


<style scoped>
    .table-card, .server-card, .menu-item {
        transition: all 0.3s ease;
    }
    .table-card:hover, .server-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 15px -5px rgba(0, 0, 0, 0.1);
    }
    .selected {
        box-shadow: 0 0 0 3px #ecc94b;
    }
    .menu-item:hover {
        background-color: #f8fafc;
    }
    .order-item {
        animation: fadeIn 0.3s ease-in;
    }
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
    /* Scrollbar personnalisée */
    .custom-scrollbar::-webkit-scrollbar {
        width: 6px;
    }
    .custom-scrollbar::-webkit-scrollbar-track {
        background: #f1f5f9;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 4px;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
    /* Transitions pour les panneaux */
    .panel-transition {
        transition: all 0.3s ease;
    }
    .toggle-panel-btn {
        transition: all 0.3s ease;
    }
    .toggle-panel-btn:hover {
        transform: scale(1.1);
    }



    .min-h-screen {
        min-height: 100vh!important;
    }

    .h-screen {
        height: 100vh!important;
    }


    .servers-list {
        padding: 0.5rem;
        max-height: 600px;
        overflow-y: auto;
    }

    .server-item {
        padding: 1rem;
        border-radius: 0.5rem;
        border: 1px solid #e2e8f0;
        margin-bottom: 0.75rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        transition: all 0.2s;
    }

    .server-item:hover {
        border-color: #3b82f6;
        background: #f1f5f9;
    }

    .server-item.unavailable {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .server-avatar {
        width: 3rem;
        height: 3rem;
        border-radius: 9999px;
        background: #dbeafe;
        color: #1d4ed8;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.25rem;
    }

    .server-info {
        flex: 1;
    }

    .server-name {
        font-weight: 500;
        margin-bottom: 0.25rem;
    }

    .server-status {
        margin-bottom: 0.25rem;
    }

    .status-badge {
        font-size: 0.75rem;
        padding: 0.125rem 0.5rem;
        border-radius: 9999px;
        font-weight: 500;
    }

    .status-badge.available {
        background: #d1fae5;
        color: #065f46;
    }

    .status-badge.unavailable {
        background: #fee2e2;
        color: #991b1b;
    }

    .server-hint {
        font-size: 0.75rem;
        color: #64748b;
    }


</style>

